"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ballById = exports.DEFAULT_BALL = exports.BALLS = void 0;
/**
 * Balls: their own registry, apart from sports and venues. Each sport names
 * the ball its trainer is loaded with; a profile can ask for another.
 */
const models_1 = require("../models");
const freeze_1 = require("./freeze");
/** Same expression as v1's TrainerSim._calculateLiftCoefficient. */
const liftCoefficient = (radius, angularSpeed, speed) => -0.05 + Math.sqrt(0.0025 + (0.36 * radius * Math.abs(angularSpeed)) / Math.abs(speed));
const ball = (id, { diameter, mass, drag }) => ({
    id,
    diameter,
    mass,
    dragCoefficient: drag,
    liftCoefficient,
});
exports.BALLS = (0, freeze_1.deepFreeze)({
    tennis: ball("tennis", models_1.BallParamsBySport.TENNIS),
    padel: ball("padel", models_1.BallParamsBySport.PADEL),
    pickleball: ball("pickleball", models_1.BallParamsBySport.PICKLEBALL),
    platformTennis: ball("platformTennis", models_1.BallParamsBySport.PLATFORM_TENNIS),
});
/** The ball each sport's trainer is loaded with. */
exports.DEFAULT_BALL = Object.freeze({
    TENNIS: "tennis",
    PADEL: "padel",
    PICKLEBALL: "pickleball",
    PLATFORM_TENNIS: "platformTennis",
    // The trainer has not been redesigned to feed a lacrosse ball, so it
    // throws platform tennis balls (as v1's BallParamsBySport.LACROSSE says).
    // A trainer that feeds lacrosse balls adds a ball and changes this line.
    LACROSSE: "platformTennis",
});
/** A ball by id, if the registry has it. */
const ballById = (id) => (Object.hasOwn(exports.BALLS, id) ? exports.BALLS[id] : undefined);
exports.ballById = ballById;
